import { CM_PROPOSAL_LABEL, FINAL_CALIBRATION_LABEL } from "./Dictionary";

export const internalGradeColors: Record<string, string> = {
  "1 - Junior Consultant": "#DDB378",
  "2 - Consultant": "#E38EA8",
  "3 - Senior Consultant": "#B58FB3",
  "4 - Manager": "#6FAFA7",
  "5 - Senior Manager": "#6395BC",
};

export enum TypeMatrixEnum {
  MANAGER_PROPOSAL = "MANAGER_PROPOSAL",
  FINAL_EVALUATION = "FINAL_EVALUATION",
}

export const typeOptions = [
  { value: TypeMatrixEnum.MANAGER_PROPOSAL, label: CM_PROPOSAL_LABEL },
  { value: TypeMatrixEnum.FINAL_EVALUATION, label: FINAL_CALIBRATION_LABEL },
];

export enum MatrixViewModeV3 {
  GLOBAL = "global",
  COLLABORATOR = "collaborator",
}

export enum MatrixSizes {
  SMALL = "small",
  BIG = "big",
}

export enum ImpactLevelEnum {
  CONSERVATIVE = "CONSERVATIVE",
  STANDARD = "STANDARD",
  CHALLENGING = "CHALLENGING",
}

export const IMPACT_LABEL: Record<string, string> = {
  CONSERVATIVE: "Conservative",
  STANDARD: "Standard",
  CHALLENGING: "Challenging",
};

export type ImpactRangeInfo = {
  min: number;
  max: number;
  label: string;
  description?: string;
};

export const IMPACT_RANGES: ImpactRangeInfo[] = [
  {
    min: 0,
    max: 13,
    label: ImpactLevelEnum.CONSERVATIVE,
    description:
      "La performance si esprime in contesti a sfida molto contenuta, con attività standardizzate e minima autonomia decisionale. L'impatto sugli outcome complessivi è circoscritto o nullo.",
  },
  {
    min: 14,
    max: 25,
    label: ImpactLevelEnum.STANDARD,
    description:
      "I risultati sono da contestualizzare in contesti di sfida di media complessità, con autonomia operativa e variabilità gestibile. L'impatto è solido e visibile, pur all'interno di confini generalmente definiti.",
  },
  {
    min: 26,
    max: 27,
    label: ImpactLevelEnum.CHALLENGING,
    description:
      "Vengono affrontate sfide di particolare valore per l'organizzazione, producendo risultati di grande valore aggiunto e contribuendo a evoluzioni importanti del business, con impatto visibile oltre il proprio perimetro.",
  },
];

export const IMPACT_ROW_COLORS: Record<string, string> = {
  CONSERVATIVE: "#7152EC66",
  STANDARD: "#7152EC99",
  CHALLENGING: "#A794F3CC",
};

export const COLLABORATORS_LIMIT = {
  DEVELOPMENT: 7,
  PERFORMANCE: 10,
  GENERAL: 7,
};
